import { client } from '../../_shared/services/openapiClient';
import { authHeaders } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetInstagramPostResponse =
  paths['/api/v1/persona_instagram_posts/{id}']['get']['responses'][200]['content']['application/json']['personaInstagramPost'];

export async function getInstagramPost(postId: string): Promise<GetInstagramPostResponse> {
  const { data, error } = await client.GET('/api/v1/persona_instagram_posts/{id}', {
    params: { path: { id: postId } },
    headers: authHeaders()
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response from getInstagramPost');
  return data.personaInstagramPost;
}
